import React from "react";
import { BrowserRouter as Router, Routes, Route, useParams} from "react-router-dom";
import Layout from "./components/common/Layout/Layout";
import Home from "./components/Home/Home";
import Roles from "./components/Roles/Roles";
import General from "./components/General/General";
import EventsSummary from "./components/General/EventsSummary";
import EventStatus from "./components/General/EventStatus";
import AddingNewEvent from "./components/General/AddingNewEvent";
import WritingBriefDescription from "./components/General/WritingBriefDescription";
import AddViewComments from "./components/RiskManager/AddViewComments";
import AddViewUploads from "./components/RiskManager/AddViewUploads";
import AssignReviewers from "./components/RiskManager/AssignReviewers";
import LinkedEvents from "./components/RiskManager/LinkedEvents";
import RequestingApproval from "./components/RiskManager/RequestingApproval";
import UserManagement from "./components/RiskManager/UserManagement";
import CompleteReview from "./components/Reviewer/CompleteReview";
import Settings from "./components/Settings/Settings";
import ApproveEvents from "./components/Approver/ApproveEvents";
import ChangeFacility from "./components/OrganizationManager/ChangeFacility";
import FacilityManagement from "./components/OrganizationManager/FacilityManagement";
import DashboardReports from "./components/Reports/DashboardReports";
import GraphicalReports from "./components/Reports/GraphicalReports";
import TextReports from "./components/Reports/TextReports";
import PasswordReset from "./components/PasswordReset/PasswordReset";
import Updates_3_49_0 from "./components/NewUpdates/Updates_3_49_0";
import Updates_3_48_0 from "./components/NewUpdates/Updates_3_48_0";
import Updates_3_47_0 from "./components/NewUpdates/Updates_3_47_0";
import Updates_3_46_0 from "./components/NewUpdates/Updates_3_46_0";
import Updates_3_45_0 from "./components/NewUpdates/Updates_3_45_0";
import Updates_3_44_0 from "./components/NewUpdates/Updates_3_44_0";
import Updates_3_43_0 from "./components/NewUpdates/Updates_3_43_0";
import Updates_3_42_0 from "./components/NewUpdates/Updates_3_42_0";
import Updates_3_41_0 from "./components/NewUpdates/Updates_3_41_0";
import Updates_3_40_0 from "./components/NewUpdates/Updates_3_40_0";
import Updates_3_38_0 from "./components/NewUpdates/Updates_3_38_0";
import Updates_3_37_0 from "./components/NewUpdates/Updates_3_37_0";
import Updates_3_36_0 from "./components/NewUpdates/Updates_3_36_0";
import Updates_3_35_0 from "./components/NewUpdates/Updates_3_35_0";

// Version Mapping
const updateRoutes = {
  "3.49.0": Updates_3_49_0,
  "3.48.0": Updates_3_48_0,
  "3.47.0": Updates_3_47_0,
  "3.46.0": Updates_3_46_0,
  "3.45.0": Updates_3_45_0,
  "3.44.0": Updates_3_44_0,
  "3.43.0": Updates_3_43_0, 
  "3.42.0": Updates_3_42_0,
  "3.41.0": Updates_3_41_0,
  "3.40.0": Updates_3_40_0,
  "3.38.0": Updates_3_38_0,
  "3.37.0": Updates_3_37_0,
  "3.36.0": Updates_3_36_0,
  "3.35.0": Updates_3_35_0,
};

function UpdatesPageWrapper() {
  const { version } = useParams();
  const Component = updateRoutes[version];
  return Component ? <Component /> : <div>Version not found</div>;
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="/updates/:version" element={<UpdatesPageWrapper />} />
          <Route path="general" element={<General />} />
          <Route path="general/events-summary" element={<EventsSummary />} />
          <Route path="general/event-status" element={<EventStatus />} />
          <Route path="general/adding-new-event" element={<AddingNewEvent />} />
          <Route path="general/writing-brief-description" element={<WritingBriefDescription />} />
          <Route path="risk-manager/add-view-comments" element={<AddViewComments />} />
          <Route path="risk-manager/add-view-uploads" element={<AddViewUploads />} />
          <Route path="risk-manager/assign-reviewers" element={<AssignReviewers />} />
          <Route path="risk-manager/linked-events" element={<LinkedEvents />} />
          <Route path="risk-manager/requesting-approval" element={<RequestingApproval />} />
          <Route path="risk-manager/user-management" element={<UserManagement />} />
          <Route path="reviewer/complete-review" element={<CompleteReview />} />
          <Route path="approver/approve-events" element={<ApproveEvents />} />
          <Route path="organization-manager/change-facility" element={<ChangeFacility />} />
          <Route path="organization-manager/facility-management" element={<FacilityManagement />} />
          <Route path="reports/dashboard-reports" element={<DashboardReports />} />
          <Route path="reports/graphical-reports" element={<GraphicalReports />} />
          <Route path="reports/text-reports" element={<TextReports />} />
          <Route path="password-reset" element={<PasswordReset />} />
          <Route path="settings" element={<Settings />} />
          <Route path="roles" element={<Roles />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
